import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface RespondentColumnNameDTO {
  name: string;
}

export class RespondentColumnName {
  readonly isRespondentColumnNameRespondentColumnName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "maxSize": 100,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    RespondentColumnName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: RespondentColumnNameDTO): RespondentColumnName {
    const name = getString(dto, "name", InvalidRespondentColumnNameNameError);
    return new RespondentColumnName(
      name
    );
  }

  toDTO(): RespondentColumnNameDTO {
    const dto: RespondentColumnNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length > 100) {
      throw new InvalidRespondentColumnNameNameMaxSizeError(
        100,
        `Attribute name is too long. Size is ${name.length}. Max size is 100.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidRespondentColumnNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

RespondentColumnName.prototype.toString = function toString(): string {
  return `RespondentColumnName(name='${this.name}')`;
};

export class InvalidRespondentColumnNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnNameError";
  }
}
export class InvalidRespondentColumnNameNameError extends InvalidRespondentColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnNameNameError";
  }
}

export class InvalidRespondentColumnNameNameMaxSizeError extends InvalidRespondentColumnNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnNameNameMaxSizeError";
  }
}

export class InvalidRespondentColumnNameNameNonEmptyError extends InvalidRespondentColumnNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnNameNameNonEmptyError";
  }
}
